<template>
  <div
    style="height:50px; width:50px;"
    class="cursor-pointer rounded-lg border-2 border-transparent hover:border-primary/25"
    @click.stop="$emit('show-program', program.id)"
  >
    <img
      v-if="program.logo"
      :src="`${program.logo.url}`"
      :alt="program.name"
      class="shadow-custom rounded-lg"
    >
    <div
      v-else
      class="h-full items-center justify-center flex bg-gray-200 shadow custom rounded-lg"
    >
      {{ program.id }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ProgramSnapshot} from "@/program/interfaces/Program";
import Consumer from "@/core/interfaces/consumers/Consumer";
import {onMounted} from "vue";
import {pathwayApi} from "@/container";

const props = defineProps<{
    program: ProgramSnapshot,
    customer: object,
    consumer: Consumer
}>();

defineEmits(['show-program']);

onMounted(() => {
    if (props.program.next_step && props.program.next_step.pathway_id) {
        pathwayApi().track('notification-show', props.program.next_step.pathway_id, props.consumer.key);
    }
});
</script>
